import EnterpriseIdentificationForm from '../components/company/EnterpriseIdentificationForm';
import { PageContainer } from '../components/layout/PageContainer';

export default function CompanyPage() {
  return (
    <PageContainer>
      <EnterpriseIdentificationForm />
    </PageContainer>
  );
}
